module.exports = __webpack_public_path__ + "0c84923bb9c683aa999bbf80a4cda2de.png";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/assets/images/ProductionShiftReportSection3.png
// module id = 315
// module chunks = 0